/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState } from 'react';
import { Col, ListGroup } from 'react-bootstrap';

export interface IKanbanListProps {
    id: any;
    listRef: any;
    extraProps?: any;
    title?: string;
    onTitleChange?({ id, title }: any): void;
    onCardAdd?(id: any): void;
    onListDelete?(id: any): void;
    addCardLabel?: string;
    children: any;
}

export const KanbanList = (props: IKanbanListProps) => {
    const { id, listRef, extraProps = {} } = props;
    const [isTitleEditable, setIsTitleEditable] = useState(false);

    const toggleIsTitleEditable = () => {
        setIsTitleEditable(!isTitleEditable);
    };

    return (
        <Col ref={listRef} {...extraProps}>
            <ListGroup className="kanban-list">{props.children}</ListGroup>
        </Col>
    );
};

KanbanList.defaultProps = {
    addCardLabel: 'Add',
};
